import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/performance/hok.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c265d522")

_pushScopeId("data-v-c265d522")
const _hoisted_1 = { style: {"height":"100%","display":"flex","flex-direction":"column"} }
const _hoisted_2 = { style: {"position":"fixed","z-index":"1000","top":"0","left":"0","right":"0"} }
const _hoisted_3 = {
  class: "new_head",
  style: {"width":"100%","background":"#2d3136","height":"62px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("img", {
      style: {"height":"44px","width":"48px","border-radius":"10px","margin-right":"10px"},
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createVNode("span", {
    class: "geo-style2",
    style: {"font-size":"21px","color":"#fff"}
  }, "HOK皮肤性能平台")
], -1)
const _hoisted_5 = { style: {"padding-top":"62px","flex-grow":"1"} }
const _hoisted_6 = {
  style: {"width":"100%","padding":"50px","background":"#222529","height":"100%"},
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_7 = {
  class: "testMain",
  style: {"background":"#2d3136"}
}
const _hoisted_8 = {
  style: {"display":"flex","justify-content":"space-between","align-items":"center","background":"#2d3136","color":"#fff","padding":"10px 10px"},
  class: "hok_label"
}
const _hoisted_9 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_10 = { class: "current_img" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("切换英雄皮肤")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("查看批量皮肤")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_14 = { class: "spacName" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h5", { style: {"color":"#fff"} }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("局内皮肤性能数据")
], -1)
const _hoisted_16 = { style: {"color":"#70c1f1"} }
const _hoisted_17 = { class: "spacName" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h5", { style: {"color":"#fff"} }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("局外皮肤性能数据")
], -1)
const _hoisted_19 = { style: {"color":"#70c1f1"} }
const _hoisted_20 = { style: {"color":"#70c1f1"} }
const _hoisted_21 = { class: "spacName" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h5", { style: {"color":"#fff"} }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("局内性能皮肤趋势图")
], -1)
const _hoisted_23 = {
  "element-loading-background": "#393E44",
  style: {"width":"100%","height":"350px"},
  id: "skin_inside"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("h5", { style: {"color":"#fff","font-size":"1.25rem"} }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("局外性能皮肤趋势图")
], -1)
const _hoisted_25 = {
  "element-loading-background": "#393E44",
  style: {"width":"100%","height":"350px"},
  id: "skin_out"
}
const _hoisted_26 = {
  class: "testMain",
  style: {"background":"#2d3136"}
}
const _hoisted_27 = {
  class: "hok_is_pass",
  style: {"text-align":"right","margin-bottom":"10px"}
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("仅显示不达标")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("导出表格")
const _hoisted_30 = { class: "all_table_hok" }
const _hoisted_31 = { class: "all_table_hok_box" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "all_table_hok_left radios-top" }, "版本", -1)
const _hoisted_33 = { class: "radil_list" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("全版本 ")
const _hoisted_35 = { class: "all_table_hok_box" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "all_table_hok_left" }, "测试用例", -1)
const _hoisted_37 = { class: "radil_list" }
const _hoisted_38 = { class: "radil_list" }
const _hoisted_39 = { class: "all_table_hok_box" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "all_table_hok_left" }, "英雄皮肤", -1)
const _hoisted_41 = { class: "radil_list" }
const _hoisted_42 = { class: "all_table_hok_box" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "all_table_hok_left" }, "上线时间", -1)
const _hoisted_44 = { class: "radil_list" }
const _hoisted_45 = { class: "all_table_hok_box" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "all_table_hok_left radios-bottom" }, "设备", -1)
const _hoisted_47 = {
  style: {"height":"45px","border-bottom":"0px solid #606469"},
  class: "radil_list_device"
}
const _hoisted_48 = { class: "ellipsis-text" }
const _hoisted_49 = { class: "spacName" }
const _hoisted_50 = {
  key: 1,
  class: "my-table-hok-out"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_domestic_standard = _resolveComponent("domestic-standard")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", null, [
          _createVNode("span", null, [
            _createVNode("img", {
              style: {"height":"50px","width":"55px","border-radius":"25px"},
              src: 
                'https://dayu.woa.com/avatars/' + _ctx.name_img + '/profile.jpg'
              
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.activeName,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.activeName = $event)),
          class: "demo-tabs hok_tab",
          onTabClick: _ctx.handleClickTab
        }, {
          default: _withId(() => [
            _createVNode(_component_el_tab_pane, {
              label: "性能详情",
              name: "first"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("span", _hoisted_10, [
                        _createVNode("img", { src: _ctx.skin_icon }, null, 8, ["src"])
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", null, _toDisplayString(_ctx.hero_name + "-" + _ctx.skin_name + _ctx.getSelectedSkinGender), 1)
                      ])
                    ]),
                    _createVNode("div", null, [
                      (_ctx.checkHok)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            size: "mini",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkHok = false))
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.checkHok)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            type: "primary",
                            size: "mini",
                            onClick: _ctx.openBatchGenerateSkins
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_el_form, {
                            key: 2,
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择英雄" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.onHeroChange,
                                    filterable: "",
                                    modelValue: _ctx.hero_id,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.hero_id = $event))
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hokIcon?.hero_list, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.hero_id,
                                          label: item.hero_name,
                                          value: item.hero_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "选择皮肤" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.skin_name,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.skin_name = $event)),
                                    onChange: _ctx.onSkinNameChange
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.curSkinNames, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.skin_name,
                                          label: `${item.skin_name}`,
                                          value: item.skin_name + ''
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "选择性别" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.curSkin,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.curSkin = $event)),
                                    size: "mini",
                                    placeholder: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.curSkins, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: _ctx.genderOptions[item.gender],
                                          value: `${item.skin_id}&${item.gender}`
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirm()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_13
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createVNode(_component_el_table, {
                      class: "my-table-hok",
                      "span-method": _ctx.mergeCells1,
                      size: "mini",
                      "header-cell-style": {
                    background: '#42484E',
                    color: '#fff',
                  },
                      "element-loading-background": "#42484E",
                      data: _ctx.hok_inside_table
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          width: "230",
                          label: "机型"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(_ctx.extractBracketContents(scope.row.model)
                          .textOutsideBrackets), 1),
                            _createVNode("span", _hoisted_16, _toDisplayString(_ctx.extractBracketContents(scope.row.model)
                          .textInsideBrackets), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "帧率" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.frame_rate), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "标准" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString("≥" + scope.row.data.baseline), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "210",
                          label: "版本日期"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("span", {
                              style: 
                          'margin-left:' +
                          (scope.row.data.level == 0 ? '0px' : '10px')
                        
                            }, [
                              _createTextVNode(_toDisplayString(scope.row.data.date), 1),
                              (scope.row.data.level == 0 && scope.row.show)
                                ? (_openBlock(), _createBlock("i", {
                                    key: 0,
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.expandCheck(scope.row)),
                                    class: 
                            scope.row.check
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-up'
                          
                                  }, null, 10, ["onClick"]))
                                : _createCommentVNode("", true)
                            ], 4),
                            (scope.row.many)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.expandCheckAdd(scope.row)),
                                  style: {"color":"#70c1f1","cursor":"pointer"}
                                }, "(查看更多)", 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "结论" }, {
                          default: _withId((scope) => [
                            _createVNode("span", {
                              class: 
                          scope.row.data.risk == '达标'
                            ? 'com_risk_green'
                            : 'com_risk_red'
                        
                            }, _toDisplayString(scope.row.data.risk), 3)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgFps" }, {
                          default: _withId((scope) => [
                            _createVNode("span", {
                              class: 
                          scope.row.data.avg_fps_risk ? 'com_risk_red' : ''
                        
                            }, _toDisplayString(scope.row.data.avg_fps), 3)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "minFps" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.min_fps), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "帧率方差" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.var_fps), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgCpu" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.avg_cpu), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgGpu" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.gpu_usage), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "maxPss" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.max_pss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgPss" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.avg_pss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "maxVss" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.max_vss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgVss" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.avg_vss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "链接" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, [
                              _createVNode("a", {
                                target: "_blank",
                                style: {"cursor":"pointer","color":"#70c1f1"},
                                href: scope.row.data.url
                              }, "查看", 8, ["href"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["span-method", "data"]), [
                      [_directive_loading, _ctx.inside_loading]
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createVNode(_component_el_table, {
                      class: "my-table-hok",
                      size: "mini",
                      "header-cell-style": {
                    background: '#42484E',
                    color: '#fff',
                  },
                      "element-loading-background": "#42484E",
                      data: _ctx.hok_out_table,
                      "span-method": _ctx.mergeCells
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          width: "170",
                          label: "机型"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(_ctx.extractBracketContents(scope.row.model)
                          .textOutsideBrackets), 1),
                            _createVNode("span", _hoisted_19, _toDisplayString(_ctx.extractBracketContents(scope.row.model)
                          .textInsideBrackets), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "帧率" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.frame_rate), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "标准" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString("≥" + scope.row.data.baseline), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "动作",
                          prop: "action"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("span", _hoisted_20, _toDisplayString(scope.row.action), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "210",
                          label: "版本日期"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("span", {
                              style: 
                          'margin-left:' +
                          (scope.row.data.level == 0 ? '0px' : '10px')
                        
                            }, [
                              _createTextVNode(_toDisplayString(scope.row.data.date), 1),
                              (scope.row.data.level == 0 && scope.row.show)
                                ? (_openBlock(), _createBlock("i", {
                                    key: 0,
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.expandCheckOut(scope.row)),
                                    class: 
                            scope.row.check
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-up'
                          
                                  }, null, 10, ["onClick"]))
                                : _createCommentVNode("", true)
                            ], 4),
                            (scope.row.many)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.expandCheckOutAdd(scope.row)),
                                  style: {"color":"#70c1f1","cursor":"pointer"}
                                }, "(查看更多)", 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "结论" }, {
                          default: _withId((scope) => [
                            _createVNode("span", {
                              class: 
                          scope.row.data.risk == '达标'
                            ? 'com_risk_green'
                            : 'com_risk_red'
                        
                            }, _toDisplayString(scope.row.data.risk), 3)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgFps" }, {
                          default: _withId((scope) => [
                            _createVNode("span", {
                              class: 
                          scope.row.data.avg_fps_risk ? 'com_risk_red' : ''
                        
                            }, _toDisplayString(scope.row.data.avg_fps), 3)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "minFps" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.min_fps), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "帧率方差" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.var_fps), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgCpu" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.avg_cpu), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgGpu" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.gpu_usage), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "maxPss" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.max_pss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgPss" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.avg_pss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "maxVss" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.max_vss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "avgVss" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.data.avg_vss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "链接" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, [
                              _createVNode("a", {
                                target: "_blank",
                                style: {"cursor":"pointer","color":"#70c1f1"},
                                href: scope.row.data.url
                              }, "查看", 8, ["href"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data", "span-method"]), [
                      [_directive_loading, _ctx.out_loading]
                    ])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_el_form, {
                      class: "spacName hok_label_form",
                      inline: true,
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "选择设备" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.device_in,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.device_in = $event)),
                              size: "mini",
                              filterable: "",
                              placeholder: "选择设备",
                              onChange: _ctx.deviceInChange
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_list, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.model,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "选择指标" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.target_index,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.target_index = $event)),
                              size: "mini",
                              filterable: "",
                              placeholder: "选择指标",
                              onChange: _ctx.hokinsideChange
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.target_types, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_card, {
                      class: "hok_card",
                      style: {"background":"#393e44","border":"1px solid #fff"}
                    }, {
                      default: _withId(() => [
                        _withDirectives(_createVNode("div", _hoisted_23, null, 512), [
                          [_directive_loading, _ctx.inside_trend_loading]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", null, [
                    _hoisted_24,
                    _createVNode(_component_el_form, {
                      class: "spacName hok_label_form",
                      inline: true,
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "选择设备" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.device_out,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.device_out = $event)),
                              size: "mini",
                              filterable: "",
                              onChange: _ctx.deviceOutChange,
                              placeholder: "选择设备"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_out_list, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.model,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "选择动作" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.action,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.action = $event)),
                              size: "mini",
                              filterable: "",
                              placeholder: "选择动作",
                              onChange: _ctx.actionChange
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kingAction, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "选择指标" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.target_index_out,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.target_index_out = $event)),
                              size: "mini",
                              filterable: "",
                              placeholder: "选择指标",
                              onChange: _ctx.hokoutChange
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.target_types, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_card, {
                      class: "hok_card",
                      style: {"background":"#393e44","border":"1px solid #fff"}
                    }, {
                      default: _withId(() => [
                        _withDirectives(_createVNode("div", _hoisted_25, null, 512), [
                          [_directive_loading, _ctx.out_trend_loading]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              disabled: _ctx.inside_loading,
              label: "新性能详情",
              name: "demostic-standard"
            }, {
              default: _withId(() => [
                _createVNode(_component_domestic_standard, {
                  hokIcon: _ctx.hokIcon,
                  activeTab: _ctx.activeName
                }, null, 8, ["hokIcon", "activeTab"])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_tab_pane, {
              disabled: _ctx.out_trend_loading,
              label: "性能总表",
              name: "second"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _createVNode(_component_el_checkbox, {
                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.all_skin_data_api(true))),
                      modelValue: _ctx.is_pass,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.is_pass = $event))
                    }, {
                      default: _withId(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      style: {"margin-left":"20px"},
                      size: "mini",
                      type: "primary",
                      onClick: _ctx.exportSkin
                    }, {
                      default: _withId(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode("div", _hoisted_33, [
                        _createVNode(_component_el_radio_group, {
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.all_skin_data_api(true))),
                          size: "small",
                          modelValue: _ctx.radio_versions,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.radio_versions = $event))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_radio, { label: '全版本' }, {
                              default: _withId(() => [
                                _hoisted_34
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skin_versions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                label: item,
                                key: item
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode("div", _hoisted_37, [
                        _createVNode("div", _hoisted_38, [
                          _createVNode(_component_el_radio_group, {
                            onChange: _ctx.test_change,
                            size: "small",
                            modelValue: _ctx.radio_test,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.radio_test = $event))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.test_type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_radio, {
                                  label: item.value,
                                  key: item
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"]),
                          (_ctx.radio_test == 3)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.all_skin_data_api(true))),
                                size: "mini",
                                modelValue: _ctx.hero_skin,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.hero_skin = $event))
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.test_type_chek, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.name,
                                      label: item.name,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode("div", _hoisted_41, [
                        _createVNode(_component_el_form, {
                          style: {"margin":"0px"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_radio_group, {
                                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.all_skin_data_api(true))),
                                  size: "small",
                                  modelValue: _ctx.hero_check,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.hero_check = $event))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hero_list, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_radio, {
                                        label: item,
                                        key: item
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(item), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (_ctx.hero_check == '英雄和皮肤')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: "选择英雄"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.heroSkinChange,
                                      filterable: "",
                                      modelValue: _ctx.hero_check_id,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.hero_check_id = $event))
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hokIcon?.hero_list, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.hero_id,
                                            label: item.hero_name,
                                            value: item.hero_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.hero_check == '英雄和皮肤')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 1,
                                  label: "选择皮肤"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.all_skin_data_api(true))),
                                      modelValue: _ctx.skin_check_id,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.skin_check_id = $event))
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hokIcon?.skin_list?.[_ctx.hero_check_id], (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: `${item.skin_id}~${item.gender}`,
                                            label: item.skin_name,
                                            value: item.skin_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode("div", _hoisted_44, [
                        _createVNode(_component_el_radio_group, {
                          size: "small",
                          modelValue: _ctx.radio_time,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.radio_time = $event))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.time_list, (item) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                label: item.value,
                                key: item
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_el_date_picker, {
                          size: "mini",
                          modelValue: _ctx.year,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.year = $event)),
                          type: "daterange",
                          onChange: _ctx.timeChange,
                          "range-separator": "To",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期"
                        }, null, 8, ["modelValue", "onChange"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createVNode("div", _hoisted_47, [
                        _createVNode(_component_el_radio_group, {
                          onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.all_skin_data_api(true))),
                          size: "small",
                          modelValue: _ctx.radio_device,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.radio_device = $event))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.devices_versions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                label: item.id,
                                key: item
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tooltip, {
                                    content: item.model,
                                    placement: "top"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("span", _hoisted_48, _toDisplayString(item.model), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["content"])
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_49, [
                    (_ctx.radio_test == 4)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                          key: 0,
                          class: "my-table-hok",
                          size: "mini",
                          "header-cell-style": {
                    background: '#42484E',
                    color: '#fff',
                  },
                          "span-method": _ctx.mergeCells2,
                          "element-loading-background": "#42484E",
                          data: _ctx.all_skin_data,
                          onSortChange: _ctx.sort_change
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              width: "100",
                              label: "ID"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.model), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              width: "100",
                              label: "英雄"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.skin_info.hero_name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              width: "100",
                              label: "皮肤"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.skin_info.skin_name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "date",
                              width: "270",
                              label: "测试日期"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: 
                          'margin-left:' +
                          (scope.row.data.level == 0 ? '0px' : '10px')
                        
                                }, [
                                  _createTextVNode(_toDisplayString(scope.row.data.date), 1),
                                  (scope.row.data.level == 0 && scope.row.show)
                                    ? (_openBlock(), _createBlock("i", {
                                        key: 0,
                                        style: {"cursor":"pointer"},
                                        onClick: ($event: any) => (_ctx.expandCheck_all(scope.row)),
                                        class: 
                            scope.row.check
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-up'
                          
                                      }, null, 10, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 4),
                                (scope.row.many)
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.expandCheck_all_add(scope.row)),
                                      style: {"color":"#70c1f1","cursor":"pointer"}
                                    }, "(查看更多)", 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "date",
                              width: "100",
                              label: "结论"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  class: 
                          scope.row.data.risk == '达标' ||
                          scope.$index == 0 ||
                          scope.$index == 1
                            ? 'com_risk_green'
                            : 'com_risk_red'
                        
                                }, _toDisplayString(scope.row.data.risk), 3)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "avg_fps",
                              sortable: "custom",
                              label: "avgFps"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  class: 
                          scope.row.data.avg_fps_risk ? 'com_risk_red' : ''
                        
                                }, _toDisplayString(scope.row.data.avg_fps), 3)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "min_fps",
                              label: "minFps"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.min_fps), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "var_fps",
                              label: "帧率方差"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.var_fps), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "avg_cpu",
                              label: "avgCpu"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.avg_cpu), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "gpu_usage",
                              label: "avgGpu"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.gpu_usage), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "max_pss",
                              label: "maxPss"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.max_pss), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "avg_pss",
                              label: "avgPss"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.avg_pss), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "max_vss",
                              label: "maxVss"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.max_vss), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              sortable: "custom",
                              prop: "avg_vss",
                              label: "avgVss"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.data.avg_vss), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "链接" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, [
                                  _createVNode("a", {
                                    target: "_blank",
                                    style: {"cursor":"pointer","color":"#70c1f1"},
                                    href: scope.row.data.url
                                  }, "查看", 8, ["href"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["span-method", "data", "onSortChange"])), [
                          [_directive_loading, _ctx.all_skin_loading]
                        ])
                      : (_openBlock(), _createBlock("div", _hoisted_50, [
                          _createVNode(_component_el_table, {
                            class: "my-table-hok",
                            size: "mini",
                            "header-cell-style": {
                      background: '#42484E',
                      color: '#fff',
                    },
                            "span-method": _ctx.mergeCells2,
                            "element-loading-background": "#42484E",
                            data: _ctx.all_skin_data,
                            onSortChange: _ctx.sort_change
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                width: "100",
                                label: "ID"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.model), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "100",
                                label: "英雄"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.data.skin_info.hero_name), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "100",
                                label: "皮肤"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.data.skin_info.skin_name), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                sortable: "custom",
                                prop: "date",
                                width: "270",
                                label: "测试日期"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    style: 
                            'margin-left:' +
                            (scope.row.data.level == 0 ? '0px' : '10px')
                          
                                  }, [
                                    _createTextVNode(_toDisplayString(scope.row.data.date), 1),
                                    (scope.row.data.level == 0 && scope.row.show)
                                      ? (_openBlock(), _createBlock("i", {
                                          key: 0,
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => (_ctx.expandCheck_all(scope.row)),
                                          class: 
                              scope.row.check
                                ? 'el-icon-arrow-down'
                                : 'el-icon-arrow-up'
                            
                                        }, null, 10, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ], 4),
                                  (scope.row.many)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.expandCheck_all_add(scope.row)),
                                        style: {"color":"#70c1f1","cursor":"pointer"}
                                      }, "(查看更多)", 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "date",
                                width: "100",
                                label: "结论"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    class: 
                            scope.row.data.risk == '达标' ||
                            scope.$index == 0 ||
                            scope.$index == 1
                              ? 'com_risk_green'
                              : 'com_risk_red'
                          
                                  }, _toDisplayString(scope.row.risk), 3)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                label: _ctx.hero_skin == 'come' ? '入场' : '待机'
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "avg_fps",
                                    sortable: "custom",
                                    label: "avgFps"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", {
                                        class: 
                              scope.row.data.avg_fps_risk ? 'com_risk_red' : ''
                            
                                      }, _toDisplayString(scope.row.data.avg_fps), 3)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "custom",
                                    prop: "min_fps",
                                    label: "minFps"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data.min_fps), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "custom",
                                    prop: "var_fps",
                                    label: "帧率方差"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data.var_fps), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "custom",
                                    prop: "avg_cpu",
                                    label: "avgCpu"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data.avg_cpu), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "custom",
                                    prop: "gpu_usage",
                                    label: "avgGpu"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data.gpu_usage), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "custom",
                                    prop: "max_pss",
                                    label: "maxPss"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data.max_pss), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "custom",
                                    prop: "avg_pss",
                                    label: "avgPss"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data.avg_pss), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "custom",
                                    prop: "max_vss",
                                    label: "maxVss"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data.max_vss), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "custom",
                                    prop: "avg_vss",
                                    label: "avgVss"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data.avg_vss), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, { label: "链接" }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, [
                                        _createVNode("a", {
                                          target: "_blank",
                                          style: {"cursor":"pointer","color":"#70c1f1"},
                                          href: scope.row.data.url
                                        }, "查看", 8, ["href"])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["span-method", "data", "onSortChange"])
                        ])),
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacName foot_hok",
                      style: {"display":"flex","align-items":"center","justify-content":"end"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "每页" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.all_skin_data_api(true))),
                              modelValue: _ctx.skin_size,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.skin_size = $event)),
                              style: {"width":"55px","height":"28px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "条记录" }),
                        _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                          default: _withId(() => [
                            _createVNode(_component_el_pagination, {
                              currentPage: _ctx.skin_page,
                              "onUpdate:currentPage": _cache[29] || (_cache[29] = ($event: any) => (_ctx.skin_page = $event)),
                              "page-size": _ctx.skin_size,
                              layout: "total, prev, pager, next, jumper",
                              total: _ctx.all_skin_data_page,
                              onCurrentChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.all_skin_data_api(false)))
                            }, null, 8, ["currentPage", "page-size", "total"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue", "onTabClick"])
      ])
    ])
  ]))
})